import React from 'react';

import { t } from '../../../../modules/infra/i18n';
import Date from '../../../common/date';
import Percentage from '../../../common/Percentage';
import { formatAmount } from '../../../common/money';

export default () => [
  {
    Header: t('products:reports.shrinkage.date_header'),
    accessor: 'dateTime',
    className: 'u-text-left',
    Cell: ({ value }) => <Date>{value}</Date>,
  },
  {
    Header: t('products:reports.shrinkage.product_name_header'),
    accessor: 'productName',
  },
  {
    Header: t('products:reports.shrinkage.sku_header'),
    accessor: 'productSku',
  },
  {
    Header: t('products:reports.shrinkage.brand_header'),
    accessor: 'productBrand',
  },
  {
    Header: t('products:reports.shrinkage.category_header'),
    accessor: 'productCategory',
  },
  {
    Header: t('products:reports.shrinkage.products_expected_header'),
    accessor: 'previousInventory',
  },
  {
    Header: t('products:reports.shrinkage.products_counted_header'),
    accessor: 'newInventory',
  },
  {
    Header: t('products:reports.shrinkage.shrinkage_percentage_header'),
    accessor: 'shrinkagePercentage',
    Cell: ({ value }) => <Percentage>{value}</Percentage>, // eslint-disable-line react/prop-types
  },
  {
    Header: t('products:reports.shrinkage.shrinkage_cost_header'),
    accessor: 'totalShrinkageCost',
    Cell: ({ value }) => formatAmount(value),
  },
];
